import React, { Component } from 'react';

import './About.css';

import en from '../../../language/en/About.json';
import es from '../../../language/es/About.json';
import { Typography } from '@material-ui/core';

class About extends Component {
	constructor() {
		super();
		this.state = {
			config: {
				en,
				es
			},
			newTask: ''
		};
	}

	render() {
		return (
			<section id="about">

				<div className="container service-bg">
					<div className="heading">
						<Typography variant="h4" className="efecto-espejo">
							Nuestros Valores
						</Typography>
					</div>
					<div className="row">
						<div className="col-sm-4">
							<div className="services sm-margin-bottom-100">
								<div className="services-wrap">
									<div className="service-body">
										<img src="assets/frontend/onepage2/img/widgets/icon1.png" alt="" />
									</div>
								</div>
								<h2>Eficaces</h2>
								<p>Damos solución a sus necesidades con la prontitud que nos caracteriza.</p>
							</div>
						</div>
						<div className="col-sm-4">
							<div className="services sm-margin-bottom-100">
								<div className="services-wrap">
									<div className="service-body">
										<img src="assets/frontend/onepage2/img/widgets/icon2.png" alt="" />
									</div>
								</div>
								<h2>Responsables</h2>
								<p>Contamos con un grupo de especialistas dedicados a la ciencia.</p>
							</div>
						</div>
						<div className="col-sm-4">
							<div className="services">
								<div className="services-wrap">
									<div className="service-body">
										<img src="assets/frontend/onepage2/img/widgets/icon3.png" alt="" />
									</div>
								</div>
								<h2>Creativos</h2>
								<p>Somos capaces de ofertar novedosas propuestas y adaptar sus necesidades a nuestro potencial.</p>
							</div>
						</div>
					</div>
				</div>

			</section>
		);
	}
}

export default About;